module.exports = __webpack_public_path__ + "assets/img/file_pdf.779c395d.png";